import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

// reducers
import { GetStatistiche as GetStatisticheReducer } from '../../reducers/r_index';
import { GetCodiciUtente as GetCodiciUtenteReducer } from '../../reducers/r_index';

//Components
import StatisticheLicenzeCmp from '../../components/statistiche/StatisticheLicenzeCmp';

// Material helpers
import { withStyles } from '@material-ui/core';

// Component styles
const styles = theme => ({
});

class StatisticheLicenze extends Component {
    
    componentDidMount() {
        // se l'utente è loggato, carico preventivamente i dati relativi all'utente loggato
        if (this.props.codiceUtente !== 'anonymous') {
            this.props.getStatistiche(this.props.codiceUtente); 

            if (this.props.codiceUtente === 'CODICEADMIN') this.props.getCodiciUtente();
        }
    }

    render() {
        const { ...props } = this.props;

        return (
            <StatisticheLicenzeCmp {...props} />
        );

    }
}

StatisticheLicenze.propTypes = {
    getStatistiche: PropTypes.func.isRequired,

    tipologia: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    generali: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    anno: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
    getStatisticheRequestStatus: PropTypes.string.isRequired,

    codiceUtente: PropTypes.string.isRequired,

    getCodiciUtente: PropTypes.func.isRequired,
    getCodiciUtenteRequestStatus: PropTypes.string.isRequired,
    codici_utente: PropTypes.arrayOf(PropTypes.string).isRequired,
};


const mapDispatchToProps = dispatch => ({
    getStatistiche: (codiceUtente) => { dispatch(GetStatisticheReducer.creators.getStatisticheRequest(codiceUtente)) },

    getCodiciUtente: () => { dispatch(GetCodiciUtenteReducer.creators.getCodiciUtenteRequest()); },
});

const mapStateToProps = state => ({
    tipologia: state['statistiche'].tipologia,
    generali: state['statistiche'].generali,
    anno: state['statistiche'].anno,
    getStatisticheRequestStatus: state['statistiche'].status,

    codiceUtente: state['logged-user'].codiceUtente,    

    getCodiciUtenteRequestStatus: state['codici-utente'].status,
    codici_utente: state['codici-utente'].codici_utente,
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(StatisticheLicenze));